// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1j2Bs","load8":"Loader_load8__2pLw8"};